<template>
  <v-form ref="form" v-model="formFieldsValid" lazy-validation>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pMultiselect'" :item="itemTipoLotto" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
              <v-col><v-text-field :label="locLotto.codice ? 'Numero lotto' : 'Numero lotto (auto)'" hide-details outlined dense disabled :value="codice"></v-text-field></v-col>
              <v-col><component :is="'pData'" :item="itemData" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense>
              <v-col lg="6"><component :is="'pMultiselect'" :item="itemMagazzino" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>            
          </v-card>  
        </v-col>
        <v-col cols="12" lg="6" xl="6">
          <v-card class="pt-1 pl-1 pr-1">
            <v-row dense>
              <v-col><component :is="'pClifor'" :item="itemFornitore" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnlySeModifica" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
            <v-row dense>
              <v-col><component :is="'pTesto'" :item="itemCodiceFiscale" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemPartitaIva" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
              <v-col><component :is="'pTesto'" :item="itemCodiceSdi" :appoggio="locLotto.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/></v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import clienti from '@/services/clientiService.js'
import pMultiselect from '../../elementi/multiselect'
import pData from '../../elementi/data'
import pClifor from '../../elementi/clifor'
import pTesto from '../../elementi/testo'

export default {
  components: {
    pMultiselect,
    pData,
    pClifor,
    pTesto
  },
  props: {
    locLotto: Object,
    trigger: Number,
    filtraTipiLotto: Array,
    mostraParcheggio: Boolean
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto,
    updateTrigger: 1
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
  },
  watch: {
    async locLotto(value) {
      // this.locLotto = await documenti.getLotto(value)
      // this.locLotto = value
    },
    trigger() {

    }
  },
  computed: {
    lottoItems() {
      if (!this.locLotto || !this.backoffice || !this.updateTrigger) {
        return []
      }
      const vars = this.backoffice.documenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        // items.push({value: dot.pick(item.valueField, this.locLotto, ''), ...item})
        items.push({value: _.get(this, `locLotto.${item.valueField}`, ''), ...item})
      }
      // console.log(items)
      return items
    },
    codice() {
      return this.trigger && this.locLotto && this.locLotto.codice
    },
    cliente() {
      return _.get(this.locLotto, 'anagrafica.cliente')
    },
    pagamentoVisibile() {
      return this.locLotto && this.locLotto.appoggio && this.locLotto.appoggio.pagamentoVisibile
    },
    clienteVisibile() {
      return this.locLotto && this.locLotto.appoggio && this.locLotto.appoggio.clienteVisibile
    },
    fornitoreVisibile() {
      return this.locLotto && this.locLotto.appoggio && this.locLotto.appoggio.fornitoreVisibile
    },
    spedizioneVisibile() {
      return this.locLotto && this.locLotto.appoggio && this.locLotto.appoggio.spedizioneVisibile
    },
    magazzinoVisibile() {
      return this.trigger && this.locLotto && this.locLotto.tipoLotto && ['fatturaImmediata', 'ddt'].includes(this.locLotto.tipoLotto.codice)
    },
    sede() {
      const destinazione = _.get(this.locLotto, 'spedizione.destinazione', null)
      if (destinazione) {
        return destinazione
      } else {
        return this.cliente.recapiti.length > 0 ? this.cliente.recapiti[0] : {} 
      }
    },
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza lotto'
      } else {
        return this.locLotto && this.locLotto._id ? 'Modifica lotto' : 'Nuovo lotto'
      }
    },
    drawerSubtitle() {
      return this.updateTrigger ? _.get(this.locLotto, 'tipoLotto.descrizione', '') : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['documenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    },
    readOnlySeModifica() {
      return _.get(this, 'locLotto.codice', '') !== ''
    },
    itemTipoLotto() {
      return {
        "model": "tipoNumerazioneLotto.codice",
        "subModel": "codice",
        "valueField": "tipoNumerazioneLotto.codice",
        "type": "Multiselect",
        "label": "Tipo numerazione",
       //  "source": "documenti_parametri.tipiLotto",
        "source": this.filtraTipiLotto && this.filtraTipiLotto.length > 0 ? this.filtraTipiLotto : "lotti.tipiNumerazioneLotto",
        "required": true,
        "addForbidden": true,
        value: _.get(this.locLotto, 'tipoNumerazioneLotto.codice', 'automatico')
      }
    },
    itemData() {
      return  {
        "model": "data",
        "valueField": "data",
        "label": "Data",
        "type": "Data",
        "required": true,
        value: _.get(this.locLotto, 'data', '')
      }
    },
    itemMagazzino() {
      return {
        "model": "magazzino",
        "subModel": "codice",
        "valueField": "magazzino",
        "type": "Multiselect",
        "label": "Magazzino movimento",
        "source": "	magazzino_magazzini.magazzini",
        "required": true,
        "addForbidden": true,
        value: _.get(this.locLotto, 'magazzino', '')
      }
    },
    itemCliente() {
      return {
        "model": "anagrafica.cliente",
        "valueField": "anagrafica.cliente",
        "label": "Cliente",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.clienteVisibile",
        "note": "tipo Cliente + solo se causale con mostra cliente",
        value: _.get(this.locLotto, 'anagrafica.cliente', '')
      }
    },
    itemFornitore() {
      return {
        "model": "anagrafica.fornitore",
        "valueField": "anagrafica.fornitore",
        "label": "Fornitore",
        "type": "Clifor",
        "required": false,
        // "showIf": "appoggio.fornitoreVisibile",
        "note": "tipo Fornitore + solo se causale con mostra fornitore",
        value: _.get(this.locLotto, 'anagrafica.fornitore', '')
      }
    },
    itemDestinazione() {
      return {
        "model": "spedizione.destinazione",
        "subModel": "codice",
        "valueField": "spedizione.destinazione",
        "note": "prende i recapiti del cliente (attenzione, required in alternativa a indirizzo temporaneo)",
        "type": "Destinazioni",
        "label": "Destinazione",
        "source": "destinatario",
        "required": false,
        "addForbidden": false,
        // "showIf": "appoggio.spedizioneVisibile",
        value: _.get(this.locLotto, 'spedizione.destinazione', '')
      }
    },
    itemCodiceFiscale() {
      return {
        "model": "appoggio.clifor.amministrativi.codiceFiscale",
        "valueField": "appoggio.clifor.amministrativi.codiceFiscale",
        "label": "Codice Fiscale",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locLotto, 'appoggio.clifor.amministrativi.codiceFiscale', '')
      }
    },
    itemPartitaIva() {
      return {
        "model": "appoggio.clifor.amministrativi.partitaIva",
        "valueField": "appoggio.clifor.amministrativi.partitaIva",
        "label": "Partita Iva",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locLotto, 'appoggio.clifor.amministrativi.partitaIva', '')
      }
    },
    itemCodiceSdi() {
      return {
        "model": "appoggio.clifor.fatturazione.codiceSdi",
        "valueField": "appoggio.clifor.fatturazione.codiceSdi",
        "label": "Codice Sdi",
        "type": "Testo",
        "readonly": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locLotto, 'appoggio.clifor.fatturazione.codiceSdi', '')
      }            
    },
    itemPagamentoCondizioni() {
      return {
        "note": "a rate, completo, anticipo",
        "model": "pagamento.condizioni",
        "subModel": "codice",
        "valueField": "pagamento.condizioni",
        "type": "Multiselect",
        "label": "Condizioni pagamento",
        "source": "documenti_pagamento.condizioniPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locLotto, 'pagamento.condizioni', '')
      }
    },
    itemPagamentoModalita() {
      return {
        "model": "pagamento.dettaglio.modalita",
        "subModel": "codice",
        "valueField": "pagamento.dettaglio.modalita",
        "type": "Multiselect",
        "label": "Modalità pagamento",
        "source": "documenti_pagamento.modalitaPagamento",
        "required": true,
        "addForbidden": true,
        "update": this.updateTrigger,
        // "showIf": "appoggio.pagamentoVisibile",
        value: _.get(this.locLotto, 'pagamento.dettaglio.modalita', '')        
      }
    }    
  },
  methods: {
    items(idx) {
      const ret = this.lottoItems && this.lottoItems.length >= idx ? this.lottoItems[idx] : {}
      console.log('ret', ret)
      return ret
    },
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value ? value[subModel] : ''
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locLotto, tgt)
      await this.aggiornaCorrelati(data)
      this.$emit('aggiornaLotto', this.locLotto)
      // this.$store.commit('documenti/SET_DOCUMENTO', this.locLotto) // verificare se va fatta store_temp
    },
    async aggiornaCorrelati(data) {
      // this.locLotto.appoggio = this.locLotto.appoggio || {}
      switch (data.model) {
         case 'tipoLotto.codice':
          this.locLotto.appoggio.tipoLotto = data.value
          this.locLotto.appoggio.clienteVisibile = _.get(data.value, 'visualizzaCliente', false)
          this.locLotto.appoggio.fornitoreVisibile = _.get(data.value, 'visualizzaFornitore', false)
          this.locLotto.appoggio.spedizioneVisibile = _.get(data.value, 'infoSpedizione', false)
          this.locLotto.appoggio.pagamentoVisibile = _.get(data.value, 'infoPagamento', false)
          this.locLotto.tipoLotto = data.value
          // this.locLotto.tipoLottoDescrizione = data.value.descrizione
          this.updateTrigger++
          break;
        case 'anagrafica.cliente':
        case 'anagrafica.fornitore':
          const clienteId = data.value.codice
          const clifor = await clienti.getCliente(clienteId)
          // this.locLotto.appoggio.clifor = clifor
          _.set(this.locLotto,'appoggio.clifor', clifor)
          _.set(this.locLotto, 'pagamento.condizioni', _.get(clifor, 'amministrativi.pagamento.condizioni', ''))
          _.set(this.locLotto, 'pagamento.dettaglio.modalita', _.get(clifor, 'amministrativi.pagamento.dettaglio.modalita', ''))
          const sede = clifor.recapiti.length > 0 ? clifor.recapiti.find(x => x.tipo.codice === 'principale') : {}
          _.set(this.locLotto, 'spedizione.destinazione', sede)
          _.set(this.locLotto, data.model + '.amministrativi', _.get(clifor, 'amministrativi', ''))
          _.set(this.locLotto, data.model + '.fatturazione', _.get(clifor, 'fatturazione', ''))         
          this.updateTrigger++
          break;
        case 'spedizione.destinazione':
          _.set(this.locLotto, 'spedizione.destinazione', data.value)
          break;
        default:
          this.updateTrigger++
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('documenti/SET_REFRESH')
      this.$store.commit('documenti/CLEAR_DOCUMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('documenti/SET_DOCUMENTO', this.locLotto)
        this.$store.commit('documenti/SET_DOCUMENTO_SAVED')
      }
    }
  }
}
</script>
